module.exports = __webpack_public_path__ + "static/media/amaranth.e25a227c.jpg";